import type { PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { Spinner } from "../../components/ui";
import { useSession, type Role } from "./SessionProvider";

export function SessionBoundary({ roles, children }: PropsWithChildren<{ roles?: readonly Role[] }>) {
  const { member, loading } = useSession();
  const location = useLocation();
  if (loading) return <div className="p-5 text-center"><Spinner label="驗證登入狀態" /></div>;
  if (!member) return <Navigate to="/login" replace state={{ returnTo: `${location.pathname}${location.search}` }} />;
  if (roles && !roles.includes(member.role)) return <Navigate to="/forbidden" replace />;
  return children;
}

